import ScpCharacteristicClient from '../ble/scpCharacteristicClient';
import HIDCommunicatorClient from '../hid/hidCommunicatorClient';
import connectivityService from './connectivityService';

export default class IqosCommunicatorClient {
    constructor(props) {
        return connectivityService.isUsb() ? new HIDCommunicatorClient(props) : new ScpCharacteristicClient(props);
    }
}
